import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import * as Sentry from '@sentry/react';
import { Toaster } from 'react-hot-toast'
import { useEffect, useState } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { useRoutes } from 'react-router-dom'
import { prefixer } from 'stylis'
import { wrapUseRoutes } from '@sentry/react'
import rtlPlugin from 'stylis-plugin-rtl'
import './assets/fonts/fontiran.css'
import InstallPrompt from './components/InstallPrompt'
import UpdateModal from './components/UpdateModal'
import { store } from './redux/store'
import './style.css'
import theme from './theme'
import routes from './routes'
import Status500 from './components/Status500'

const useSentryRoutes = wrapUseRoutes(useRoutes);

function App(): JSX.Element {
    const content = useSentryRoutes(routes);

    // State
    const [updateModal, setUpdateModal] = useState(false)
    const [registration, setRegistration] = useState<ServiceWorker>()

    const isPWAInstalled = window.matchMedia(
        '(display-mode: standalone)'
    ).matches

    const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            window.navigator.userAgent || navigator.userAgent
        )

    // RTL
    const cacheRtl = createCache({
        key: 'kuknos-rtl',
        stylisPlugins: [prefixer, rtlPlugin],
    })

    const openModal = (evt: MessageEvent): void => {
        if (evt.data.type === 'update_available') {
            setUpdateModal(true)
            setRegistration(evt.data.reg)
        }
    }
    // Effect for checking update
    useEffect(() => {
        window.addEventListener('message', openModal)

        return () => {
            window.removeEventListener('message', openModal, false)
        }
    }, [])

    return (
        <Sentry.ErrorBoundary fallback={<Status500 />} showDialog>
            <ReduxProvider store={store}>
                <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        {/* <SystemRoutes /> */}
                        {content}
                        <Toaster position="top-center" />
                        {isMobile ? !isPWAInstalled && <InstallPrompt /> : null}
                        {/* Update Modal */}
                        {updateModal && (
                            <UpdateModal
                                registration={registration}
                                open={updateModal}
                                toggle={() => setUpdateModal((prev) => !prev)}
                            />
                        )}
                    </ThemeProvider>
                </CacheProvider>
            </ReduxProvider>
        </Sentry.ErrorBoundary>
    )
}

export default App
